module.exports = __webpack_public_path__ + "img/fi-rr-makeup-brush.24daeafb.svg";